import { APP_CONFIG } from "@shared/config";
import { AppName } from "@shared/config/types/AppName";

export function initTitle(){
    let title = APP_CONFIG.appName === AppName.imlink ? 'ImLink' : 'Sigma SMS'
    document.title = title + ' | Integration'
}